import { Row, Col, Breadcrumb } from "react-bootstrap";

const BreadCrumbs = () => {
  return (
    <Row>
      <Col xs="12">
        <Breadcrumb className="leap">
          <Breadcrumb.Item href="/certificatesofregistration">
            Certificates Of Registration
          </Breadcrumb.Item>
        </Breadcrumb>
      </Col>
    </Row>
  );
};

export default BreadCrumbs;
